import groupBy from 'lodash/groupBy'

export default function collections(state = {}, action) {
  switch (action.type) {
    case 'RECEIVE_COLLECTION': {
      return {
        ...state,
        [action.payload.permalink.toLowerCase()]: action.payload,
      }
    }

    default:
      return state
  }
}

export function getCollectionByPermalink(state, permalink) {
  return state[permalink.toLowerCase()]
}

export function getDisplayGroupsInCollection(state, permalink) {
  if (!(permalink.toLowerCase() in state)) {
    return []
  }

  const collection = getCollectionByPermalink(state, permalink)
  return collection.groupings.display_group ?? []
}

export function getProductsInCollectionGroup(state, permalink, productGroupId) {
  if (!(permalink.toLowerCase() in state)) {
    return []
  }

  const collection = getCollectionByPermalink(state, permalink)
  return groupBy(collection.products, 'product_group_id')[productGroupId] || []
}
